(function () {
  document.addEventListener('DOMContentLoaded', function () {

    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-drawer-overlay');
    var closeBtn = document.getElementById('cart-drawer-close');
    var itemsEl = document.getElementById('cart-drawer-items');
    var countEl = document.getElementById('cart-drawer-count');
    var totalEl = document.getElementById('cart-drawer-total');
    var recommendList = document.getElementById('cart-drawer-recommend-list');
    var noteToggle = document.getElementById('cart-drawer-note-toggle');
    var noteTextarea = document.getElementById('cart-drawer-note');

    if (!drawer) return;

    function formatMoney(cents) {
      return 'Rs.' + (cents / 100).toLocaleString('en-PK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.classList.add('cart-drawer-open');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.classList.remove('cart-drawer-open');
    }

    window.CartDrawer = {
      open: openDrawer,
      close: closeDrawer,
      refresh: refreshCart,
      addToCart: addToCart
    };

    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    if (noteToggle && noteTextarea) {
      noteToggle.addEventListener('click', function () {
        noteTextarea.style.display = noteTextarea.style.display === 'none' ? 'block' : 'none';
      });
      noteTextarea.addEventListener('change', function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteTextarea.value })
        });
      });
    }

    function renderCart(cart) {
      countEl.textContent = cart.item_count;
      totalEl.textContent = formatMoney(cart.total_price);

      if (cart.items.length === 0) {
        itemsEl.innerHTML = '<p class="cdm-empty">Your cart is empty</p>';
        return;
      }

      var html = '';
      cart.items.forEach(function (item, index) {
        html += '<div class="cdm-item" data-line="' + (index + 1) + '">' +
          '<a href="' + item.url + '" class="cdm-item-image">' +
            '<img src="' + item.image + '" alt="' + item.product_title + '">' +
          '</a>' +
          '<div class="cdm-item-info">' +
            '<a href="' + item.url + '" class="cdm-item-title">' + item.product_title + '</a>' +
            '<div class="cdm-item-price">' + formatMoney(item.price) + ' x ' + item.quantity + '</div>' +
            '<div class="cdm-qty-row">' +
              '<button class="cdm-qty-btn" data-qty-decrease type="button">-</button>' +
              '<span class="cdm-qty-value">' + item.quantity + '</span>' +
              '<button class="cdm-qty-btn" data-qty-increase type="button">+</button>' +
            '</div>' +
          '</div>' +
          '<button class="cdm-remove" data-remove type="button">Remove</button>' +
        '</div>';
      });
      itemsEl.innerHTML = html;

      itemsEl.querySelectorAll('[data-qty-increase]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var row = btn.closest('.cdm-item');
          var line = row.dataset.line;
          var qty = parseInt(row.querySelector('.cdm-qty-value').textContent, 10);
          updateLine(line, qty + 1);
        });
      });
      itemsEl.querySelectorAll('[data-qty-decrease]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var row = btn.closest('.cdm-item');
          var line = row.dataset.line;
          var qty = parseInt(row.querySelector('.cdm-qty-value').textContent, 10);
          updateLine(line, Math.max(0, qty - 1));
        });
      });
      itemsEl.querySelectorAll('[data-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var row = btn.closest('.cdm-item');
          updateLine(row.dataset.line, 0);
        });
      });
    }

    function updateLine(line, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          renderCart(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        });
    }

    function refreshCart() {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) { renderCart(cart); });
    }

    function loadRecommendations(productId) {
      if (!productId || !recommendList) return;
      fetch('/recommendations/products.json?product_id=' + productId + '&limit=6')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = data.products || [];
          if (products.length === 0) {
            recommendList.innerHTML = '';
            return;
          }
          var html = '';
          products.forEach(function (p) {
            var price = (p.price / 100).toLocaleString('en-PK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            var compareHtml = '';
            if (p.compare_at_price && p.compare_at_price > p.price) {
              var comparePrice = (p.compare_at_price / 100).toLocaleString('en-PK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              compareHtml = '<s class="cdr-compare">Rs.' + comparePrice + '</s>';
            }
            var img = p.featured_image || (p.images && p.images[0]) || '';
            html += '<div class="cdr-item">' +
              '<a href="' + p.url + '" class="cdr-item-image"><img src="' + img + '" alt="' + p.title + '"></a>' +
              '<div class="cdr-item-info">' +
                '<a href="' + p.url + '" class="cdr-item-title">' + p.title + '</a>' +
                '<div class="cdr-item-price">Rs.' + price + ' ' + compareHtml + '</div>' +
                '<button class="cdr-add-btn" data-recommend-add type="button" data-variant-id="' + p.variants[0].id + '">+ Add to Cart</button>' +
              '</div>' +
            '</div>';
          });
          recommendList.innerHTML = html;

          recommendList.querySelectorAll('[data-recommend-add]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              addToCart(btn.dataset.variantId, 1);
            });
          });
        })
        .catch(function () {});
    }

    function addToCart(variantId, quantity) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function (item) {
          if (item.status) {
            console.error(item.description);
            return;
          }
          refreshCart();
          loadRecommendations(item.product_id);
          openDrawer();
        })
        .catch(function (err) { console.error('Add to cart error:', err); });
    }

    // ---- GLOBAL HOOKS ----

    // 1) Koi bhi standard Shopify <form action="/cart/add"> submit ho
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.tagName === 'FORM' && form.action && form.action.indexOf('/cart/add') !== -1) {
        e.preventDefault();
        var formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function (res) { return res.json(); })
          .then(function (item) {
            if (item.status) {
              console.error(item.description);
              return;
            }
            refreshCart();
            loadRecommendations(item.product_id);
            openDrawer();
          })
          .catch(function (err) { console.error(err); });
      }
    });

    // 2) Koi bhi button jisme data-ajax-add-to-cart ho (variant id se)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ajax-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.dataset.variantId;
      var qty = btn.dataset.quantity || 1;
      if (!variantId) return;
      addToCart(variantId, qty);
    });

    // 3) Jo buttons already apna fetch('/cart/add.js') kar ke 'cart:refresh' event bhejte hain
    //    (jaise product-recommendations.liquid ke "Add to Bag" buttons)
    document.addEventListener('cart:refresh', function () {
      refreshCart();
      openDrawer();
    });

    // Cart icon (header) click karne par bhi drawer khule — agar tumhare header me
    // cart icon hai to usko class/id "cart-icon-toggle" de dena, ya niche line edit kar lena
    var cartIconTriggers = document.querySelectorAll('[data-cart-drawer-open], a[href="/cart"]');
    cartIconTriggers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        refreshCart();
        openDrawer();
      });
    });

    // Initial cart load (taake count sahi dikhe)
    refreshCart();
  });
})();